module.exports = __webpack_public_path__ + "static/media/bear_bedroom_electronics.c6fb8921.png";